import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from '../components/Footer';
import Chatbot from '../components/Chatbot';
import '../styles/LegalPage.css';

export default function Legal() {
  const { t } = useTranslation();

  const privacyRef = useRef(null);
  const termsRef = useRef(null);

  // Scroll to appropriate section on mount and on hash change
  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash === '#privacy' && privacyRef.current) {
        privacyRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (hash === '#terms' && termsRef.current) {
        termsRef.current.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    handleHashScroll(); // Scroll on first load
    window.addEventListener('hashchange', handleHashScroll); // Scroll on hash change

    return () => {
      window.removeEventListener('hashchange', handleHashScroll);
    };
  }, []);

  return (
    <>
      <Navbar />

      <div className="legal-container">
        <div className="legal-box">
          <h1>{t('privacy_terms_title')}</h1>

          {/* Privacy Policy Section */}
          <section ref={privacyRef} id="privacy">
            <h2>{t('section1_title')}</h2>
            <p>{t('section1_content')}</p>
            <h2>{t('section2_title')}</h2>
            <p>{t('section2_content')}</p>
            <h2>{t('section3_title')}</h2>
            <ul>
              {t('section3_points', { returnObjects: true }).map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
            <h2>{t('section4_title')}</h2>
            <p>{t('section4_content')}</p>
          </section>

          {/* Terms of Service Section */}
          <section ref={termsRef} id="terms">
            <h2>{t('section5_title')}</h2>
            <p>{t('section5_content')}</p>
            <h2>{t('section6_title')}</h2>
            <p>{t('section6_content')}</p>
            <h2>{t('section7_title')}</h2>
            <p>
              {t('section7_content')}{' '}
              <a href="mailto:support@healthaiapp.com">support@healthaiapp.com</a>
            </p>
          </section>

          <footer className="legal-footer">
            <p>&copy; {new Date().getFullYear()} HW AI. {t('legal_footer')}</p>
          </footer>
        </div>
      </div>

      <Footer />
      <Chatbot />
    </>
  );
}